<template>
  <div class="competences">
    <div class="competences-header">
      <h1>My main skills</h1>
    </div>
    <div class="competences-body">
      <SavoirFaire v-for="sf in savoirFairesPrincipaux"
                v-bind:key="sf.title"
                v-bind:title="sf.title"
                v-bind:img="sf.img"
                v-bind:note="sf.note"
                v-bind:description="sf.description"/>
    </div>
    <div class="competences-header">
      <h1>My other skills</h1>
    </div>
    <div class="competences-body">
      <SavoirFaire v-for="sf in savoirFairesSecondaires"
                   v-bind:key="sf.title"
                   v-bind:title="sf.title"
                   v-bind:img="sf.img"
                   v-bind:note="sf.note"
                   v-bind:description="sf.description"/>
    </div>
  </div>
</template>
<script>
import SavoirFaire from "@/components/SavoirFaire";
export default {
  name: 'Competences',
  components: {
    SavoirFaire,
  },
  data: function() {
    let savoirFairesPrincipaux = [
      { id: 1,
        title: 'Front-end Development - JS / TS',
        img: 'JavaScript-logo.webp',
        description: "Lead front-end developer on projects using Svelte, Angular, and more recently, React. Use of Typescript, Vite/Rollup, Jest...",
        note: 4,
      },
      { id: 4,
        title: 'Authentication',
        img: 'ping.webp',
        description: "Thanks to my experience in IAM Team, I've learned many things about Oauth2 authentication.",
        note: 3,
      },
      { id: 2,
        title: 'Continuous Integration',
        img: 'jenkins.webp',
        description: "Developed CI pipelines on Jenkins and GitHub Actions using existing libraries.",
        note: 3,
      },
      { id: 3,
        title: 'Containerization',
        img: 'docker.webp',
        description: "Creation of several DockerFiles and DockerCompose files.",
        note: 3,
      }
    ];

    let savoirFairesSecondaires = [
      { id: 1,
        title: 'GitHub',
        img: 'github.webp',
        description: "Proficient in GitHub and its features (PR, Issues, Project...).",
        note: 4,
      },
      { id: 2,
        title: 'Jira',
        img: 'jira.webp',
        description: "Used Jira in the context of agile methodologies.",
        note: 3,
      },
      { id: 3,
        title: 'Back-end Development - PHP',
        img: 'php.webp',
        description: "Completed a full project on Symfony 4, explored API Platform.",
        note: 2,
      },
      { id: 4,
        title: 'Back-end Development - Java',
        img: 'java.webp',
        description: "Completed school projects (checkers game...) and made some fixes in a company setting.",
        note: 2,
      },
      { id: 5,
        title: 'English',
        img: 'anglais.webp',
        description: "TOEIC score: 920 (including 490/495 in listening).",
        note: 4,
      },
      { id: 6,
        title: 'Data Science',
        img: 'ml.webp',
        description: "Completed school projects in machine learning (regressions, decision trees, neural networks...).",
        note: 2,
      },
    ];
    return {
      savoirFairesPrincipaux, savoirFairesSecondaires
    }
  }
}
</script>
<style>
.competences{
  width: 100%;
}
.competences h1{
  margin: auto auto auto 10px;
}
.competences-header{
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
}
.competences-body{
  margin-left: 10px;
  display: flex;
  flex-wrap: wrap;
}
</style>